import { render } from "./vaccountfd.vue?vue&type=template&id=f10f696a&scoped=true"
import script from "./vaccountfd.vue?vue&type=script&lang=js"
export * from "./vaccountfd.vue?vue&type=script&lang=js"

import "./vaccountfd.vue?vue&type=style&index=0&id=f10f696a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f10f696a"]])

export default __exports__